import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    apopUser: null,
    signedIn: false
  },
  mutations: {
    SET_APOP_USER (state, apopUser) {
      state.apopUser = apopUser
    },
    SET_SIGNED_IN (state, signedIn) {
      state.signedIn = signedIn
    }
  },
  actions: {
    updateSignedInUser (context, apopUser) {
      context.commit('SET_APOP_USER', apopUser)
      context.commit('SET_SIGNED_IN', !!apopUser)
    },
    completeSignOut (context) {
      context.commit('SET_APOP_USER', null)
      context.commit('SET_SIGNED_IN', false)
    }
  }
})

export default store
